export async function fetchSimulationById(apiBaseUrl, authToken, simulationId) {
    try {
        const response = await fetch(`${apiBaseUrl}/simulation?simulation_id=${simulationId}`, {
            headers: { 'Authorization': `Token ${authToken}` },
        });

        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Failed to fetch simulations:', err.message);
        return [];
    }
}